import { type ReactElement } from 'react'
import SuccessCheck from './SuccessCheck'

interface Props {
  message?: string
  tid?: string
}

export default function Success ({ message = 'Got it', tid }: Props): ReactElement {
  return (
    <div className="my-4 flex justify-center" data-tid={tid}>
      <div className="w-7 h-7 mr-3">
        <SuccessCheck />
      </div>
      <p className="text-green-700 flex self-center font-cursive">{message}</p>
    </div>
  )
}
